import InlineNotification from './InlineNotification';
import { InlineNotificationProps, InlineNotificationValueProps } from './types';

export type { InlineNotificationProps, InlineNotificationValueProps };
export default InlineNotification;
